import * as React from 'react'
import {
  IconButton,
  Chip,
  ClickAwayListener,
  Typography,
  Modal,
  Box,
  List,
  ListItemText,
  ListItem,
  Divider,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { makeStyles } from '@material-ui/core/styles'
import { withStyles } from '@material-ui/core/styles'
import StickyNote2Icon from '@mui/icons-material/StickyNote2'
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined'
import moment from 'moment-timezone'
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    alignContent: 'center',
  },
  inline: {
    display: 'inline',
  },
  chipRoot: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
    color: 'white',
    height: 'auto',
    backgroundColor: '#666',
    borderRadius: '5px',
  },
  chipLabel: {
    maxWidth: '490px',
    // overflow: 'unset !important',
    // whiteSpace: 'normal !important',
  },
  listAvatar: {
    minWidth: 24,
    marginRight: 16,
    '& > svg': {
      color: '#666',
      height: 24,
      width: 24,
    },
  },
  listItemText: {
    fontSize: 14,
  },
  primaryText: {
    fontSize: '14px',
    color: '#666',
  },
  primaryTextPH: {
    fontWeight: '700',
  },
  primaryTextEmail: {
    textDecoration: 'unset',
    fontWeight: '700',
    '&:hover': {
      textDecoration: 'unset',
    },
  },
  secondaryTextHref: {
    // textDecoration: 'unset',
    color: '#fff',
    '&:hover': {
      // textDecoration: 'unset',
    },
  },
  iconClass: {
    minWidth: '36px !important',
  },
  menuRoot: {
    fontSize: '14px',
    color: '#666',
  },
  strickyHeader: {
    top: '0px',
    left: '0px',
    position: 'sticky',
    background: 'white',
    zIndex: 2,
  },
  boxStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '450px',
    width: 'auto',
    height: 'auto',
    minHeight: '30%',
    backgroundColor: 'white',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  },
  notesField: {
    fontSize: '16px',
    fontWeight: 'bold',
    margin: '5px',
    wordBreak: 'break-word',
  },
}))
// const HtmlTooltip = styled(({ ...props }) => (
//     <Tooltip {...props} />
//   ))(({ theme }) => ({
//     [`& .${tooltipClasses.tooltip}`]: {
//       backgroundColor: '#f5f5f9',
//       color: 'rgba(0, 0, 0, 0.87)',
//       maxWidth: 220,
//       fontSize: theme.typography.pxToRem(12),
//       border: '1px solid #dadde9',
//     },
//   }));

export const NotesIconFlyout = ({ params = {}, clikedOn = '' }) => {
  const [open, setOpen] = React.useState(false)
  const classes = useStyles()
  const { notes = [], fileName = '', qaNotes = '' } = params
  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipToggle = () => {
    setOpen(!open)
  }
  const getPrimaryQAText = (qaNotes = '') => {
    return (
      <span>
        <>{qaNotes}</>
      </span>
    )
  }
  const getPrimaryText = (fullName = '', formatDate = '') => {
    return (
      <span>
        <>
          {`  `}
          <span className={classes.primaryTextPH}>{fullName}</span>
        </>
        <>
          {` added the notes`}
          {` on `}
        </>
        <span className={classes.primaryTextPH}>{formatDate}</span>
      </span>
    )
  }
  const CustomTooltip = withStyles((theme) => ({
    tooltip: {
      fontSize: 12,
    },
    popper: {
      zIndex: 3301,
    },
  }))(Tooltip)
  const getAddDataString = (notes = []) => {
    return (
      <CustomTooltip title={(notes || '').length > 250 ? notes : ''}>
        <Typography className={classes.notesField} variant="body2">
          {(notes || '').length > 250 ? notes.substring(0, 250) + '...' : notes}
        </Typography>
      </CustomTooltip>
    )
  }
  const renderContent = () => {
    const renderNoteRow = (notesObject, idx, total) => {
      const {
        created_by = {},
        created_dt = '',
        note: addedNotes = '',
      } = notesObject || {}
      const {
        first_name = '',
        last_name = '',
        display_name = '',
      } = created_by || {}
      const fullName = display_name || `${first_name} ${last_name}`
      const formattedDate = moment(created_dt).format('YYYY-MM-DD')

      return (
        <React.Fragment key={`${created_dt || 'note'}-${idx}`}>
          <ListItem alignItems="flex-start">
            <ListItemText
              className={classes.listItemText}
              primary={getPrimaryText(fullName, formattedDate)}
              secondary={<div>{getAddDataString(addedNotes)}</div>}
            />
          </ListItem>
          {idx < total - 1 && <Divider component="li" />}
        </React.Fragment>
      )
    }

    return (
      <>
        <IconButton onClick={handleTooltipToggle}>
          <StickyNote2Icon color="primary" />
        </IconButton>
        <Modal
          open={open}
          onClose={handleTooltipClose}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
        >
          <Box className={classes.boxStyle}>
            <IconButton
              aria-label="close"
              onClick={handleTooltipClose}
              style={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: '#666',
                zIndex: 1,
              }}
              size="small"
            >
              <CloseIcon />
            </IconButton>
            <div
              style={{
                border: '1px solid #dadde9',
                borderRadius: '6px',
                backgroundColor: '#f5f5f5',
              }}
            >
              <Typography
                style={{
                  margin: '10px',
                  borderRadius: '6px',
                  fontWeight: 600,
                  display: 'inline-block',
                }}
                variant="h5"
              >
                {fileName} - Notes
              </Typography>
            </div>
            <List className={classes.root}>
              {clikedOn === 'notes'
                ? (notes || []).map((notesObject, idx) =>
                    renderNoteRow(notesObject, idx, (notes || []).length)
                  )
                : qaNotes && (
                    <React.Fragment key={'qaNotes'}>
                      <ListItem alignItems="flex-start">
                        <ListItemText
                          className={classes.listItemText}
                          secondary={<div>{getAddDataString(qaNotes)}</div>}
                        />
                      </ListItem>
                    </React.Fragment>
                  )}
            </List>
          </Box>
        </Modal>
      </>
    )
  }

  return <>{renderContent()}</>
}

export const NotesChipFlyout = ({ index, tag, notes }) => {
  const [open, setOpen] = React.useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipToggle = () => {
    setOpen(!open)
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        onClose={handleTooltipClose}
        open={open}
        placement="right-start"
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={
          <React.Fragment>
            <Typography color="inherit" variant="body1">
              {tag}
            </Typography>
            <Typography variant="body2">{notes}</Typography>
          </React.Fragment>
        }
        sx={{
          [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: 'white',
            border: '1px solid #dadde9',
          },
        }}
      >
        <Chip
          key={index}
          label={tag}
          icon={<StickyNote2OutlinedIcon sx={{ '&&': { color: '#1976d2' } }} />}
          onClick={handleTooltipToggle}
          size="small"
          style={{ marginRight: 7, marginBottom: 7 }}
        />
      </Tooltip>
    </ClickAwayListener>

    //     <ClickAwayListener onClickAway={handleTooltipClose}>
    //     <div>
    //       <Tooltip
    //         PopperProps={{
    //           disablePortal: true,
    //         }}
    //         onClose={handleTooltipClose}
    //         open={open}
    //         disableFocusListener
    //         disableHoverListener
    //         disableTouchListener
    //         title="Add"
    //       >
    //         <Button onClick={handleTooltipOpen}>Click</Button>
    //       </Tooltip>
    //     </div>
    //   </ClickAwayListener>
  )
}
